import { render, staticRenderFns } from "./COPY-ME.vue?vue&type=template&id=a4d10f4e&scoped=true"
import script from "./COPY-ME.vue?vue&type=script&lang=js"
export * from "./COPY-ME.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d10f4e",
  null
  
)

export default component.exports